import React, {useEffect, useState} from "react";
// import service from "../service";
import SearchItem from "./SearchItem";
import {useParams, useHistory} from "react-router-dom";
import "./search.css";

const EXTURL = 'https://api.documenu.com/v2/restaurants/search/fields?key=dae1adbe76c43e4a90fcc9f67fd412ea';

const SearchList = ({zip}) => {
    console.log(zip)
    const searchTerm = useParams().searchTerm;
    const searchName = useParams().searchName;
    const history = useHistory();

    const[results, setResults] = useState({data:[]});
    // window.location.reload(false);
    console.log(searchTerm)
    let newUrl = EXTURL;
    if (searchTerm) {
        newUrl = newUrl + "&zip_code=" + searchTerm;
    }
    else {
        newUrl = newUrl + "&zip_code=" + zip + "&size=3";
    }

    if (searchName) {
        newUrl = newUrl + "&restaurant_name=" + searchName;
    }
    else {
        // do nothing
    }
    console.log(newUrl);

    const findResults = () =>
        fetch(newUrl)
            .then(res => res.json())
            .then(results => setResults(results));

    useEffect(findResults,[searchTerm, searchName, zip]);
    console.log(results);

    const search = results;

    return(
        <>
            {
                search.data.map(hot => {
                    return(<SearchItem hotel = {hot}/>)
                })
            }
        </>

    )
};


export default SearchList;
